<template>


    <div v-if="isSuccess">
        <el-alert v-if="isSuccess"
                  title="Kích hoạt tài khoản thành công, vui lòng đăng nhập hệ thống để sử dụng"
                  type="success">

        </el-alert>
        <login v-bind:is-auto-login="false">

        </login>
    </div>
    <div v-else>
        <el-alert title="Kích hoạt tài khoản thất bại"
                  type="error">

        </el-alert>
        <resend-confirm-registration>

        </resend-confirm-registration>
    </div>


</template>

<script>
    import Login from "./Login"
    import {confirmRegistration} from "../services/authentication_service"
    import ResendConfirmRegistration from "./ResendConfirmRegistration"

    export default {
        name: "ConfirmRegistration",
        components: {Login, ResendConfirmRegistration},
        data() {
            return {
                isSuccess: false
            }
        },
        created() {
            confirmRegistration(this.$route.query.token,
                this.onSuccess,
                this.onError,
                () => {
                }
            )
        },
        methods: {
            onSuccess() {
                this.isSuccess = true

            }
            ,
            onError(message) {
                this.$data.isSuccess = false
            }
        }

    }
</script>

<style scoped>

</style>